// NEW_FILE_JUSTIFIED: Custom hook for MyInsurancePage — extracts query + derived stats to keep component under 200 lines
import { useQuery } from 'convex/react';
import { useLocation } from 'react-router-dom';
import { api } from '../../convex/_generated/api'; // DEEP_IMPORT_JUSTIFIED: hooks need direct convex api access
import type { IPortalPolicy } from '@/@types/insurance';

export function useMyInsurancePage() {
  const { pathname } = useLocation();
  const basePath = pathname.startsWith('/company') ? '/company/my-insurance' : '/my-insurance';

  const rawPolicies = useQuery(api.insurance.policies.listForPortalUser);
  const isLoading = rawPolicies === undefined;
  const policies: IPortalPolicy[] = rawPolicies ?? [];

  const stats = {
    total: policies.length,
    active: policies.filter((p: IPortalPolicy) => p.status === 'active').length,
    expired: policies.filter((p: IPortalPolicy) => p.status === 'expired').length,
    coveredPersons: policies.reduce(
      (sum: number, p: IPortalPolicy) => sum + 1 + p.dependants.length,
      0
    ),
  };

  return { basePath, policies, isLoading, stats };
}
